import React, { useEffect, useState } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import testBluePng from "../../../../assets/images/courses/TestIcon.svg";
import arrowLeft from "../../../../assets/images/courses/arrow-left-solid.svg";
import { useLocation } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import TestsTable from "../../../../components/tables/testsTable";
import PagePagination from "../../../../components/tables/pagination";
import { useHistory } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import { useSelector } from "react-redux";

const Tests = () => {
    const DATE_OPTIONS = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: false,
        timeZone: "America/Los_Angeles",
    };
    let planState = localStorage.getItem("planState");
    const locationState = useLocation();
    const [loadingData, setLoadingData] = useState(false);
    const history = useHistory();
    const role = useSelector((state) => state.layout.role);
    let note_id = locationState.state?.note_id;

    let notes = locationState.state?.notes;

    let canDoIt = locationState.state?.canDoIt;
    let testType = locationState.state?.testType;
    let noteData = locationState.state?.noteData;
    let course_id = locationState.state?.course_id;
    let courseName = locationState.state?.courseName;
    const [tests, setTests] = useState([]);
    const [count, setCount] = useState(0);
    const [showData, setShowData] = useState(10);
    const [skipData, setSkipData] = useState(0);
    const [showLimit, setShowLimit] = useState(false);
    const [testResult, setTestResult] = useState(false);
    const [isCourseNote, setIsCourseNote] = useState(false);
    const [isInvate, setIsInvate] = useState(false);

    const createTests = (val) => {
        let isData = val;
        localStorage.setItem("isCreate", true);

        history.push({
            pathname: "/createTest",
            state: {
                note_id,
                notes,
                testType,
                showLimit,
                noteData,
                isData,
                canDoIt,
                courseName,
                course_id,
            },
        });
    };

    const getNoteById = async (val) => {
        const result = await Repository.findByEndPoint(
            `api/notes/findNotesById/${note_id}`
        );

        if (result.status === 200 || result.status === 201) {
            if (result.data.data?.course != null) {
                setIsCourseNote(true);
            }
        }
    };
    const findAllTests = async () => {
        const result = await Repository.findByEndPoint(
            `api/users/findThisUser`
        );

        if (result.status === 200 || result.status === 201) {
            setIsInvate(result.data?.data?.is_invate);
            if (
                result.data?.data?.created_tests_count >=
                process.env.REACT_APP_API_NOTE_LIMIT
            ) {
                if (planState == "active") {
                    setShowLimit(false);
                } else {
                    setShowLimit(true);
                }
            }
            setTestResult(true);
        }
        return result.data?.data[0]?.length;
    };
    const findTest = async () => {
        let skipTake = {
            skip: skipData,
            take: showData,
        };
        setLoadingData(false);
        const result = await Repository.postRequest(
            `api/test/findTestsByNoteId/${note_id}`,
            skipTake
        );

        if (result.status === 200 || result.status === 201) {
            setCount(result.data.data[1]);
            let data = result.data.data[0]
                .filter((val) => val.test_type === testType)
                .map((val) => {
                    return {
                        test_id: val.test_id,
                        test_name: val.test_name,
                        test_content: val.test_content,
                        test_prompt: val.test_prompt,
                        test_type: val.test_type,
                        icon: val.icon,
                        no_of_questions: val.no_of_questions,
                        score: val.score,
                        note_id: val.note_id,
                        combo_test_id: val.combo_test_id,
                        created_at: new Date(val.created_at).toLocaleDateString(
                            "en-US",
                            DATE_OPTIONS
                        ),
                    };
                });
          
            if (note_id == undefined) {
                setLoadingData(true);
                history.push({
                    pathname: "/home",
                });
            } else if (role == "student") {
                createTests(false);
            }
            setTests(data);
            setLoadingData(true);
        }
        setLoadingData(true);
        return result.data?.data[0]?.length;
    };

    useEffect(async () => {
        localStorage.setItem("note_id", note_id);
        if (testResult) {
            findTest();
        }
    }, [showData, skipData, testResult]);

    useEffect(async () => {
        findAllTests();
        getNoteById();
    }, []);

    return loadingData ? (
        <div className="testBodyDiv homeSection">
            <div className="d-flex justify-content-between">
                <div className="clidrenDivCompakt testH1">
                    <div>
                        <img src={testBluePng} alt="testPng" />
                    </div>
                    <div className="mt-3 ">
                        <h1>
                            {noteData?.title ? noteData?.title + " - " : ""}
                            <b className="titleTest">
                                {testType == "choice"
                                    ? "Multiple Choice"
                                    : testType == "written"
                                    ? "Written"
                                    : ""}
                            </b>
                        </h1>
                    </div>
                </div>
                {(role == "instructor" && canDoIt == false) ||
                (role == "student" && canDoIt == true) ? (
                    <div className="tests">
                        {showLimit ? (
                            <div
                                className="createBtnDiv testButton"
                                onMouseOver={(e) => {
                                    e.target.innerText = "7 Day Free Trial";
                                }}
                                onMouseOut={(e) => {
                                    e.target.innerText = "NEW TEST";
                                }}
                                onClick={() => {
                                    history.push({
                                        pathname: "/subscription",
                                    });
                                }}
                            >
                                <span className="plus">+</span>
                                <span>NEW TEST</span>
                            </div>
                        ) : (
                            <div
                                id="createBtnDivTest"
                                className="createBtnDiv"
                                onClick={() => {
                                    createTests(false);
                                }}
                            >
                                <span className="plus">+</span>
                                <span>NEW TEST</span>
                            </div>
                        )}
                        <div className="testBackBtnDiv">
                            <button
                                id="testBackBtnDiv"
                                onClick={() => {
                                   
                                    if (course_id != undefined) {
                                        history.push({
                                            pathname: "/courseDetails",
                                            search: `course_id=${course_id}`,
                                            state: { courseName },
                                        });
                                    } else {
                                        history.push({
                                            pathname: "/home",
                                        });
                                    }
                                }}
                            >
                                Back
                            </button>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>

            <div className="line"></div>
            {tests.length > 0 ? (
                <div>
                    <TestsTable
                        tests={tests}
                        refreshTable={findTest}
                        setLoadingData={setLoadingData}
                        loadingData={loadingData}
                        noteData={noteData}
                        testType={testType}
                        canDoIt={canDoIt}
                        note_id={note_id}
                        notes={notes}
                        courseName={courseName}
                        course_id={course_id}
                        role={role}
                    />
                    <PagePagination
                        setShow={setShowData}
                        count={count}
                        setSkip={setSkipData}
                        skip={skipData}
                        show={showData}
                    />
                </div>
            ) : (
                <div>
                    <h5 className="nodata">No data created yet.</h5>
                </div>
            )}
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default Tests;
